export default __webpack_public_path__ + "static/media/dashboard-waiting-tickets.cd38764c.svg";